import React, { useContext } from 'react'

import { Redirect } from 'react-router'

import { Loader } from '@percept/mui'

import { DefaultLayoutComponent, isNewLayoutApp } from './layout'

import { OrgUnitContext, UserPrivilegeContext } from '@percept/app-components'

import { Organisation, useActiveOrgEnvironment } from '../components/Organisation'
import { DashboardHome } from 'components/DashboardHome'

import { OrgUnitDataWarehouseContextProvider } from './dataProviders'

import { useDocumentTitle } from '@percept/hooks'


const OrganisationScreenWithContext = (): JSX.Element => {
  const { activePlatformUnit } = useActiveOrgEnvironment()

  useDocumentTitle({
    paths: [
      activePlatformUnit && activePlatformUnit.name,
    ],
  })

  if( !activePlatformUnit ){
    return (
      <DefaultLayoutComponent>
        <OrgUnitDataWarehouseContextProvider>
          <Loader preset='fullscreen' />
        </OrgUnitDataWarehouseContextProvider>
      </DefaultLayoutComponent>
    )
  }

  return (
    <OrgUnitContext.Provider value={activePlatformUnit}>
      <OrgUnitDataWarehouseContextProvider>
        <DefaultLayoutComponent>
          <DashboardHome />
        </DefaultLayoutComponent>
      </OrgUnitDataWarehouseContextProvider>
    </OrgUnitContext.Provider>
  )
}

export const OrganisationScreen = (): JSX.Element => {
  return (
    <DefaultLayoutComponent>
      <Organisation />
    </DefaultLayoutComponent>
  )
}

export const DefaultOrganisationRedirect = (): JSX.Element => {
  const { user } = useContext(UserPrivilegeContext)
  return (
    <Redirect push={false} to={`/dashboards/${user.default_org_unit_id}`} />
  )
}

export default (
  isNewLayoutApp ?
    OrganisationScreenWithContext :
    OrganisationScreen
)

